import React, { createContext, useContext, useState, useEffect } from "react";
import { getBaseUrl } from "../Redux/Config/AppConfig";
import { useSelector } from "react-redux";

const HotelContext = createContext();
export const useHotel = () => useContext(HotelContext);

export const HotelProvider = ({ children }) => {
  const isAuthenticated = useSelector((state) => state.auth?.isAuthenticated);
  const [hotels, setHotels] = useState([]);
  const [selectedHotel, setSelectedHotel] = useState(
    localStorage.getItem("hotel_id") || ""
  );
  const [selectedHotelName, setSelectedHotelName] = useState(
    localStorage.getItem("hotel_name") || ""
  );
  const [selectedHotelUrl, setSelectedHotelUrl] = useState(
    localStorage.getItem("url") || ""
  );
  const [loading, setLoading] = useState(false);
  const baseUrl = getBaseUrl();

  // Always check role and hotel_id on mount and when role changes
  useEffect(() => {
    const checkAndFetchHotels = async () => {
      const role = localStorage.getItem("role");
      const hotelIdInStorage = localStorage.getItem("hotel_id");
      if (role === "admin") {
        setLoading(true);
        try {
          const token = localStorage.getItem("token");
          const res = await fetch(`${baseUrl}/hotel/all`, {
            method: "POST",
            headers: { Authorization: `Bearer ${token}` },
          });
          const result = await res.json();
          setHotels(result.data);
          // If no hotel_id in localStorage or selectedHotel, set to first hotel
          if (
            (!hotelIdInStorage || !selectedHotel) &&
            result?.data?.length > 0
          ) {
            setSelectedHotel(result.data[0].id);
            setSelectedHotelName(result.data[0].name);
            setSelectedHotelUrl(result.data[0].url);
            localStorage.setItem("hotel_id", result.data[0].id);
            localStorage.setItem("hotel_name", result.data[0].name);
            localStorage.setItem("url", result.data[0].url);
          }
        } catch (err) {
          // handle error
        } finally {
          setLoading(false);
        }
      } else if (role !== "super_admin" && role !== "admin" && role) {
        let userData = JSON.parse(localStorage.getItem("user") || "{}");
        localStorage.setItem("hotel_id", userData?.hotel_id);
      } else {
        // If not admin, clear hotel selection
        setHotels([]);
        setSelectedHotel("");
        setSelectedHotelName("");
        setSelectedHotelUrl("");
        localStorage.removeItem("hotel_id");
        localStorage.removeItem("hotel_name");
        localStorage.removeItem("url");
      }
    };
    checkAndFetchHotels();
    // Listen for storage events (multi-tab support)
    const handleStorage = (e) => {
      if (e.key === "role" || e.key === "hotel_id" || e.key === "user" || e.key==='hotel_name') {
        checkAndFetchHotels();
      }
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, [baseUrl, selectedHotel, isAuthenticated]);

  // Keep localStorage in sync with selectedHotel
  let userData = JSON.parse(localStorage.getItem("user") || "{}");
  useEffect(() => {
    const role = localStorage.getItem("role");

    if (selectedHotel) {
      if (userData?.role !== "admin" && userData?.hotel_id && role) {
        localStorage.setItem("hotel_id", userData?.hotel_id);
      } else {
        localStorage.setItem("hotel_id", selectedHotel);
        localStorage.setItem("hotel_name", selectedHotelName);
        localStorage.setItem("url", selectedHotelUrl);
      }
    }
  }, [selectedHotel, selectedHotelName, selectedHotelUrl,  isAuthenticated]);

  return (
    <HotelContext.Provider
      value={{
        hotels,
        selectedHotel,
        selectedHotelName,
        selectedHotelUrl,
        setSelectedHotel,
        setSelectedHotelName,
        setSelectedHotelUrl,
        loading,
      }}
    >
      {children}
    </HotelContext.Provider>
  );
};
